import styled from 'styled-components';
import Lottie from 'lottie-react';
import {Row} from 'styled/common';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0 20px;
  height: auto;
`;

export const BottomBlock = styled.div`
  display: flex;
  flex-direction: column;
  grid-row-gap: 48px;
  width: 100%;
`;

export const HelpersBlock = styled.div.attrs({className: 'iv-upload-type-view__helpers'})`
  display: flex;
  flex-direction: column;
  grid-row-gap: 8px;
  margin: 0 auto 0;
  text-align: left;
`;

export const HelpersItem = styled(Row).attrs({
  className: 'iv-upload-type-view__helper-item kiosko:text-kiosko-xs',
})`
  font-size: 12px;
  color: ${props =>
    props.theme.hasTemplate
      ? props.theme.colors.branding.fontSecondary
      : props.theme.colors.$p10};

  & > p {
    margin: 0 0 0 10px;
  }
`;

export const StyledLottieIVDocumentsAnimations = styled(Lottie)`
  width: 300px;
  margin: 0 auto 32px;
  height: 225px;
`;
